/**
 * Whether a booking form page is a move step that a locked order may not change (CU-14zcqntn47u).
 * The server refuses every `/step/` save on a locked order except the customer details step, which
 * only carries contact details, and every inventory change, so those pages show read-only and their
 * forward button moves on without saving. `/add/inventory` is the funnel's inventory page.
 */
export function isLockedStep(isLocked: boolean | null | undefined, path: string): boolean {
    const isMovePage = (path.startsWith('/step/') && path !== '/step/customer_details') || path === '/add/inventory';

    return Boolean(isLocked) && isMovePage;
}
